import { DeleteOutlined, InfoOutlined } from '@mui/icons-material';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import { Box, Divider, IconButton, Tooltip, Typography } from '@mui/material';

import { CurrencyText } from 'components/text';
import { usePedidoCompraContext } from 'context/PedidoCompraContext';
import { PedidoCompraAmmount } from 'pages/compra/pedido/components';
import { ProdutoCart } from 'pages/compra/pedido/types';

export function PedidoCartProduct({ produtoCart }: { produtoCart: ProdutoCart }) {
    const { removeProdCart, modifyProdCartQtd, getProdCartQtd, isProdutoDisabled, getProdMinQtd } = usePedidoCompraContext();
    const { produto, qtMinimaCompra } = produtoCart;
    const produtoDisabled = isProdutoDisabled(produtoCart);
    const opacity = produtoDisabled ? 0.6 : 1;
    const isAboveTenMultiplied = getProdCartQtd(produto.idProduto) >= getProdMinQtd(qtMinimaCompra) * 10;

    return (
        <>
            <Tooltip followCursor={true} title={produtoDisabled ? 'Produto indisponível para compra' : ''}>
                <Box
                    sx={{
                        display: 'flex',
                        gap: 1.5,
                    }}
                >
                    <Box
                        sx={{
                            width: 50,
                            height: 50,
                            borderRadius: 1.5,
                            border: '1px solid',
                            borderColor: 'divider',
                            backgroundColor: 'grey.50',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'contain',
                            backgroundImage: `url("${produto.lkImagem}")`,
                            opacity: opacity,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                        }}
                    >
                        {!produto.lkImagem && <InsertPhotoOutlinedIcon fontSize="large" sx={{ color: 'grey.300' }} />}
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0, justifyContent: 'space-between' }}>
                        {/* Linha 1: Nome do Produto e Alerta */}
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, opacity }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    flex: 1,
                                    minWidth: 0,
                                    fontWeight: 500,
                                    lineHeight: 1.2,
                                    wordBreak: 'break-word',
                                }}
                            >
                                {produto.dsProduto}
                            </Typography>

                            {isAboveTenMultiplied && (
                                <Tooltip title="Quantidade é igual ou superior ao múltiplo de 10 vezes a quantidade mínima do produto">
                                    <InfoOutlined color="warning" sx={{ flexShrink: 0, fontSize: '1rem' }} />
                                </Tooltip>
                            )}
                        </Box>

                        {/* Linha 2: Preço na Esquerda e Quantidade + Excluir na Direita */}
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 0.5, opacity }}>
                            <CurrencyText size="sm" value={produtoCart.vlPrecoCompra * produtoCart.qtProdutoCart} />

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <IconButton
                                    size="small"
                                    onClick={() => removeProdCart(produto.idProduto)}
                                    color="error"
                                    sx={{
                                        'p': 0.5,
                                        'color': 'text.secondary',
                                        '&:hover': { color: 'error.main' },
                                    }}
                                >
                                    <DeleteOutlined fontSize="small" />
                                </IconButton>

                                <PedidoCompraAmmount
                                    getQtd={getProdCartQtd}
                                    modifyQtd={modifyProdCartQtd}
                                    produtoPedido={produtoCart}
                                    sx={{ width: 110, height: 26, flexShrink: 0 }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Tooltip>

            <Divider sx={{ my: 1.5 }} />
        </>
    );
}
